<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <remnant-past-review
            v-if="$store.getters.authName !== '인턴십부'"
            ref="remnantPastReview"
            :email="email"
            :no-review="false"
          />
          <remnant-past-omc
            v-if="$store.getters.authName !== '인턴십부'"
            ref="remnantPastOmc"
            :email="email"
          />
          <hr>
          <b-row class="mb-2">
            <b-col md="12">
              <b-form-input
                v-model="email"
                :readonly="true"
              />
            </b-col>
          </b-row>
          <remnant-basic
            ref="remnantBasic"
            :email="email"
            :read-only="true"
          />
          <remnant-family
            ref="remnantFamily"
            :email="email"
            :read-only="true"
            :check-sibling-term="term"
          />
          <remnant-training
            ref="remnantTraining"
            :email="email"
            :read-only="true"
          />
          <hr>
          <longterm-report
            v-if="longterm > 0"
            :email="email"
            :apply-id="applyId"
            :longterm="longterm"
            :summit-lock="true"
            :initial-read-only="true"
            :no-edit="true"
          />
          <apply-info
            v-else
            :email="email"
            :apply-id="applyId"
            :initial-read-only="true"
            :no-edit="true"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import RemnantBasic from './remnant/RemnantBasic'
import RemnantFamily from './remnant/RemnantFamily'
import RemnantTraining from './remnant/RemnantTraining'
import RemnantPastReview from './remnant/RemnantPastReview'
import RemnantPastOmc from './remnant/RemnantPastOmc'
import ApplyInfo from './apply/ApplyInfo'
import LongtermReport from './apply/LongtermReport'

export default {
  name: 'ApplyList',
  components: { RemnantBasic, RemnantFamily, RemnantTraining, RemnantPastReview, RemnantPastOmc, ApplyInfo, LongtermReport },
  data: function () {
    return {
      applyId: '',
      email: '',
      term: '',
      longterm: 0
    }
  },
  created () {
    this.applyId = this.$store.state.PRINTID
    if (!this.applyId) {
      alert('경로 잘못됨')
    } else {
      let infos = this.applyId.split('-apply-')
      this.email = infos[1]
      this.term = infos[0]
      this.longterm = this.$store.state.PRINTLONGTERM
    }
    this.$store.commit('setPrintId', '')
  },
  methods: {
  }
}
</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
